// @ts-check

const selectors = Object.freeze({
  opener: '.js-open-drawer',
  closer: '.js-close-drawer',
})

export class SideDrawer extends HTMLElement {
  constructor () {
    super()
    this.opener = this.querySelector(selectors.opener)

    if (!this.opener) {
      throw new Error('SideDrawer: no opener button found')
    }

    this.opener.addEventListener('click', () => this.dispatchEvent(new CustomEvent('drawer:open')))

    this.before(this.opener)

    document.body.append(this)

    this.closers = this.querySelectorAll(selectors.closer)
    this.closers.forEach(closer => {
      closer.addEventListener('click', () => this.dispatchEvent(new CustomEvent('drawer:close')))
    })
  }

  connectedCallback () {
    console.log('SideDrawer connectedCallback')
    this.classList.remove('invisible')
    this.opener.classList.remove('invisible')
  }

  disconnectedCallback () {
    console.log('SideDrawer disconnectedCallback')
  }
}
